import React from "react";
import useDarkMode from "@/hooks/useDarkMode";
import { Link } from "react-router-dom";
import useWidth from "@/hooks/useWidth";

import WizyChatLogo from "@/assets/images/logo/wizychat.svg"
import Branding from "@/utils/branding";

const Logo = () => {
  const [isDark] = useDarkMode();
  const { width, breakpoints } = useWidth();
  const branding = Branding()

  return (
    <div>
      <a href={branding.mainSite}>
        <img
          src={branding.logo ? branding.logo : WizyChatLogo}
          className={branding.logoClasses}
        />
      </a>
    </div>
  );
};

export default Logo;
